import * as React from 'react'
import type { Components } from 'react-markdown'

import { GDSMarkdown } from '../gdsMarkdown'

import { TEXT_CONTAINING_TAG_LIST } from './constants'
import { StreamingText } from '../streamingText'

interface Props {
  readonly children: string
  readonly updateComponents?: (defaultComponentMap: Components) => Components
}
/**
 * Render markdown content with streaming animation
 */
export function StreamingMarkdownContent({
  children,
  updateComponents: propsUpdateComponents = c => c,
}: Props) {
  const visitedNodes = React.useRef(new Map<string, string>())

  const updateComponents = React.useCallback(
    (defaultComponentMap: Components) => {
      const updatedComponentMap = propsUpdateComponents(defaultComponentMap)
      const componentMap: Components = {}

      for (const tag of TEXT_CONTAINING_TAG_LIST) {
        // @ts-expect-error TS2590: Expression produces a union type that is too complex to represent
        componentMap[tag] = args => {
          const { children, node, ...props } = args
          return (
            <StreamingText
              visitedNodes={visitedNodes.current}
              render={fadableChildren => {
                const updatedComponent = updatedComponentMap[tag]
                if (!updatedComponent) {
                  return React.createElement(tag, props, fadableChildren)
                }

                if (typeof updatedComponent === 'string') {
                  return React.createElement(updatedComponent, props, fadableChildren)
                }

                return (updatedComponent as React.FC)({ ...args, children: fadableChildren })
              }}
              node={node}
            >
              {children}
            </StreamingText>
          )
        }
      }

      return componentMap
    },
    [propsUpdateComponents],
  )

  return <GDSMarkdown updateComponents={updateComponents}>{children}</GDSMarkdown>
}
